"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllSocketsManager = void 0;
class AllSocketsManager {
    constructor(orgUsersProvider) {
        this.orgUsersProvider = orgUsersProvider;
        this.orgUsersProvider = orgUsersProvider;
    }
    activeOrgUsers() {
        return this.orgUsersProvider.getActiveOrgUsers();
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            for (const orgUser of this.activeOrgUsers()) {
                const socketManager = orgUser.getSocketManager();
                if (socketManager.connectionStatus.isConnected) {
                    yield socketManager.disconnect();
                }
            }
        });
    }
    connectSockets() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.activeOrgUsers().map((orgUser) => __awaiter(this, void 0, void 0, function* () {
                const socketManager = orgUser.getSocketManager();
                if (!socketManager.connectionStatus.isConnected &&
                    !socketManager.connectionStatus.isConnecting) {
                    yield socketManager.connect();
                }
            })));
        });
    }
    allSocketsConnected() {
        return (this.activeOrgUsers().filter(u => !u.getSocketManager().connectionStatus.isConnected).length === 0);
    }
    areSocketsConnecting() {
        return this.activeOrgUsers().some(u => u.getSocketManager().connectionStatus.isConnecting);
    }
}
exports.AllSocketsManager = AllSocketsManager;
